import SpokeIcon from "@mui/icons-material/Spoke";

const PropertiesForDS = [
  {
    name: "Name",
    id: "Name",
    md: 4,
    sm: 6,
  },
  {
    name: "Contained In",
    id: "ContainedIn",
    md: 4,
    sm: 6,
    icon: <SpokeIcon sx={{ fontSize: "1.2rem", mr: "5px" }} />,
  },
  { name: "Type", id: "Type", md: 4, sm: 6 },
  { name: "Description", id: "Description", xs: 12 },
];

const DSColumns = [
  {
    id: "Name",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Attribute",
    width: 200,
  },
  {
    id: "Type",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "Type",
    width: 150,
  },
  {
    id: "References",
    numeric: false,
    disablePadding: false,
    sortable: true,
    label: "References",
    width: 200,
  },
  {
    id: "Description",
    numeric: false,
    disablePadding: false,
    sortable: false,
    label: "Description",
    width: 250,
  },
];

const TAG_COLUMN_PREFIX = "tag_";

export { DSColumns, PropertiesForDS, TAG_COLUMN_PREFIX };
